<script>
export default {
  name: "contactUs"
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #101010">
    <el-col :span="24">
      <el-row style="padding: 0 16px">
        <el-col :span="24" style="display: flex; flex-direction: row">
          <!--          <span class="contact-up-p">You've got </span>-->
          <span class="contact-up-p-bold">Questions?</span>
        </el-col>
        <!--        <el-col :span="24" style="display: flex; flex-direction: row; margin-top: 10px;">-->
        <!--          <span class="contact-up-p">We've got</span>-->
        <!--          <span class="contact-up-p-bold">&nbsp;answers!</span>-->
        <!--        </el-col>-->
      </el-row>
      <el-row>
        <el-col
          :span="24"
          style="display: flex; justify-content: center; padding: 5px 16px 5px 16px"
        >
          <div class="email-heading">
            <span
              style="font-family: Metropolis, -apple-system, Roboto, Helvetica,sans-serif; color: #ffbe00"
              >team@unifiproperty.com</span
            >
          </div>
          <!-- <el-button type="primary" class="contact-up-btn">Contact us</el-button> -->
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.contact-up-p {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 34px Metropolis, sans-serif;
  display: flex;
}

.contact-up-p-bold {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 34px Metropolis, sans-serif;
}

.contact-up-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  margin-top: 24px;
  font: 600 20px Metropolis, sans-serif;
}

.email-heading {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  flex-grow: 1;
  margin: auto 0;
  font: 400 30px Proxima Nova, sans-serif;
}

@media only screen and (max-width: 375px) {
  .contact-up-p {
    color: #ffffff;
    font-feature-settings: "clig" off, "liga" off;
    font: 400 18px Metropolis, sans-serif;
    display: flex;
  }

  .contact-up-p-bold {
    color: #ffffff;
    font-feature-settings: "clig" off, "liga" off;
    font: 600 28px Metropolis, sans-serif;
  }

  .email-heading {
    color: #fff;
    font-feature-settings: "clig" off, "liga" off;
    flex-grow: 1;
    margin: auto 0;
    font: 400 20px Proxima Nova, sans-serif;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
}
</style>



// WEBPACK FOOTER //
// src/components/package/contactUs.vue